var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sweet-modal',{ref:"preview_modal",attrs:{"blocking":"blocking","width":"80%"}},[_c('div',[_c('div',{staticClass:"embed-responsive embed-responsive-1by1"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"srcdoc":_vm.html}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }